'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp2;

var _BasketProductDetail = require('./BasketProductDetail');

var _BasketProductDetail2 = _interopRequireDefault(_BasketProductDetail);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

require('./style.less');

var _utils = require('helpers/utils');

var _components2 = require('components');

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    BasketView: {
        displayName: 'BasketView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Basket/default/BasketView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var yandexShareButtons = null;
var sharingURL = '';

var BasketView = _wrapComponent('BasketView')((_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(BasketView, _Component);

    function BasketView() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, BasketView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BasketView.__proto__ || (0, _getPrototypeOf2.default)(BasketView)).call.apply(_ref, [this].concat(args))), _this), _this.onCreateOrder = function (event) {
            event.preventDefault();
            _this.props.onCreateOrder(event);
        }, _this.cancelEditOrder = function (event) {
            event.preventDefault();
            _this.props.cancelEditOrder(event);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(BasketView, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var shareCode = this.props.shareCode;
            sharingURL = global.location.origin + '/basket/';

            if (this.props.elements.length) {
                try {
                    yandexShareButtons = Ya.share2(this.refs.yandex_buttons, {
                        content: {
                            url: global.location.origin + '/basket/' + shareCode,
                            title: this.props.cartSubject || '',
                            image: this.props.elements[0].picture && this.props.elements[0].picture.url || this.props.logo,
                            description: (0, _utils.stripTags)(this.props.cartDescription) || ''
                        },
                        theme: {
                            services: 'vkontakte,facebook,twitter,odnoklassniki'
                        }
                    });
                } catch (e) {}
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.shareCode && nextProps.shareCode !== this.props.shareCode) {
                yandexShareButtons.updateContent({
                    url: global.location.origin + '/basket/' + nextProps.shareCode
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                cartSubject = _props.cartSubject,
                cartDescription = _props.cartDescription,
                dataError = _props.dataError,
                shareCode = _props.shareCode,
                sharePreload = _props.sharePreload,
                showShare = _props.showShare,
                lang = _props.lang,
                currency = _props.currency,
                customFields = _props.customFields,
                changeCustomFields = _props.changeCustomFields;

            var elements = this.props.elements || [];
            var total = 0;

            cartSubject = cartSubject || '';
            cartDescription = cartDescription || '';

            var editOrder = null;
            if (this.props.editOrderNumber) {
                editOrder = _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-8' },
                        _react3.default.createElement(
                            'h2',
                            { className: 'section-title special_title', style: { paddingLeft: '10px' } },
                            _react3.default.createElement(
                                'span',
                                null,
                                lang['store.common.editOrder.title'],
                                ' \u2116 ',
                                this.props.editOrderNumber
                            )
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-sm-4 col-xs-12 text-right' },
                        _react3.default.createElement(
                            'div',
                            { className: 'buttons-holder', style: { paddingTop: '10px' } },
                            _react3.default.createElement(
                                'button',
                                { onClick: this.cancelEditOrder, className: 'le-button' },
                                lang['store.common.editOrder.button.cancel']
                            )
                        )
                    )
                );
            }
            if (elements.length <= 0) {
                return _react3.default.createElement(
                    'section',
                    { id: 'cart-page' },
                    _react3.default.createElement(
                        'div',
                        { className: 'row text-center' },
                        _react3.default.createElement(
                            'div',
                            { className: 'basket-empty' },
                            lang['store.cart.empty']
                        )
                    )
                );
            }

            var helmet = _react3.default.createElement(_reactHelmet2.default, {
                meta: [{ property: "og:url", content: sharingURL + shareCode }, { property: "og:type", content: "article" }, { property: "og:title", content: cartSubject }, { property: "og:description", content: (0, _utils.stripTags)(cartDescription) }, { property: "twitter:description", content: (0, _utils.stripTags)(cartDescription) }, { property: "twitter:title", content: cartSubject }]
            });

            var mailBody = encodeURIComponent((cartDescription || '') + ' \n' + global.location.origin + '/basket/' + shareCode) || "";
            var mailSubject = encodeURIComponent(cartSubject);

            return _react3.default.createElement(
                'section',
                { id: 'cart-page' },
                editOrder,
                this.props.before,
                helmet,
                _react3.default.createElement(
                    'div',
                    { className: 'row no-margin cart-item hidden-xs' },
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-1' },
                        lang['store.cart.photo']
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-4' },
                        lang['store.cart.title']
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-2' },
                        lang['store.cart.modifiers']
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-3 hidden-xs text-center' },
                        lang['store.cart.quantity']
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-2 hidden-xs text-center' },
                        lang['store.cart.price']
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'items-holder' },
                    elements.map(function (item, keyArray) {
                        var sum = item.price * item.count;
                        var itemError = null;
                        total += sum;

                        for (var i = 0; i < dataError.length; i++) {
                            if (dataError[i].offer_id == item.id && dataError[i].modifier_option_id == item.modifier_option_id) {
                                itemError = dataError[i];
                                break;
                            }
                        }

                        var props_item = (0, _extends3.default)({}, item, {
                            sum: sum,
                            itemError: itemError,
                            onChangeCount: _this2.props.onChangeCount,
                            onDelete: _this2.props.onDelete
                        });
                        var key = item.id;
                        if (item.modifier_option_id !== null) {
                            key = key + '_' + item.modifier_option_id;
                        }
                        if (item.modifier_option_name !== null) {
                            key = key + '_' + item.modifier_option_name;
                        }
                        return _react3.default.createElement(_BasketProductDetail2.default, (0, _extends3.default)({ key: keyArray, lang: lang, currency: currency, keyArray: keyArray }, props_item));
                    })
                ),
                customFields.length > 0 ? _react3.default.createElement(
                    'div',
                    { className: 'row no-margin summ_row' },
                    customFields.map(function (item, i) {
                        return _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-12 no-margin' },
                            item.type === 'text' ? _react3.default.createElement(
                                _reactBootstrap.FormGroup,
                                { className: 'col-xs-12 col-sm-7' },
                                _react3.default.createElement(
                                    _reactBootstrap.ControlLabel,
                                    null,
                                    item.name
                                ),
                                _react3.default.createElement('input', {
                                    id: i,
                                    value: item.value,
                                    className: 'form-control',
                                    type: 'text',
                                    onChange: changeCustomFields
                                })
                            ) : _react3.default.createElement(
                                _reactBootstrap.FormGroup,
                                { className: 'col-xs-12 col-sm-7' },
                                _react3.default.createElement('input', { type: 'checkbox', className: 'form-check-input', id: i, onChange: changeCustomFields, checked: item.value }),
                                _react3.default.createElement(
                                    'label',
                                    { className: 'form-check-label', htmlFor: i },
                                    '\xA0 ',
                                    item.name
                                )
                            )
                        );
                    })
                ) : null,
                _react3.default.createElement(
                    'div',
                    { className: 'row no-margin summ_row' },
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-3 no-margin' },
                        _react3.default.createElement(
                            'div',
                            { className: 'social_row ' + (showShare ? "enable" : "") },
                            !showShare ? _react3.default.createElement(
                                'div',
                                { className: 'buttons-holder inline_block button_width_100' },
                                _react3.default.createElement(
                                    'a',
                                    { onClick: this.props.shareBasket, className: 'le-button big button_width_100' },
                                    _react3.default.createElement(
                                        'span',
                                        null,
                                        _react3.default.createElement('i', { className: 'fa fa-share-alt' }),
                                        ' ',
                                        lang['store.cart.share'],
                                        ' '
                                    )
                                )
                            ) : _react3.default.createElement(
                                'a',
                                { className: 'le-button button_share', onClick: this.props.hideShare },
                                _react3.default.createElement('i', { className: 'fa fa-times' })
                            ),
                            showShare ? _react3.default.createElement(
                                'a',
                                { href: 'mailto:?subject=' + mailSubject + '&body=' + mailBody, title: lang['store.cart.send_email'], className: 'le-button button_share button_add' },
                                _react3.default.createElement('i', { className: 'fa fa-envelope' })
                            ) : null,
                            showShare ? _react3.default.createElement(
                                'a',
                                { className: 'le-button button_share button_add', title: lang['store.cart.copy_to_clipboard'], onClick: this.props.copyToBuffer },
                                _react3.default.createElement('i', { className: 'fa fa-clone' })
                            ) : null
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-2 no-margin' },
                        this.props.user ? _react3.default.createElement(
                            'div',
                            null,
                            _react3.default.createElement(
                                'div',
                                { className: 'buttons-holder inline_block button_width_100' },
                                _react3.default.createElement(
                                    'a',
                                    { onClick: this.props.postponeBasket, className: 'le-button big button_width_100' },
                                    _react3.default.createElement(
                                        'span',
                                        null,
                                        lang['store.postpone.buttonPostpone'],
                                        ' '
                                    )
                                )
                            )
                        ) : null
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-6 no-margin text-right' },
                        _react3.default.createElement(
                            'div',
                            { className: 'total_price' },
                            _react3.default.createElement(_components2.MoneyValue, {
                                value: total,
                                icon: currency.icon,
                                iconAfterValue: currency.icon_after_value,
                                prefix: lang['store.cart.total'] + ': '
                            })
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'buttons-holder inline_block button_width_100' },
                            _react3.default.createElement(
                                'a',
                                { href: '#', onClick: this.onCreateOrder, className: 'le-button big button_width_100' },
                                lang['store.cart.checkout']
                            )
                        )
                    )
                )
            );
        }
    }]);
    return BasketView;
}(_react2.Component), _class.defaultProps = {
    dataError: []
}, _class.propTypes = {
    elements: _react2.PropTypes.array.isRequired,
    onDelete: _react2.PropTypes.func.isRequired,
    onChangeCount: _react2.PropTypes.func.isRequired,
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object
}, _temp2));

exports.default = BasketView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Basket/default/BasketView.jsx
// module id = 1620
// module chunks = 0